

import { Cpu, Zap, Star, Target, ShieldCheck } from "lucide-react";

export const Metrics = () => {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-display font-bold text-center mb-16 uppercase tracking-widest text-gray-400">What changes with QuantumHire</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 text-center">
          <div className="group">
            <div className="w-16 h-16 rounded-2xl bg-brand-secondary flex items-center justify-center mx-auto mb-6 group-hover:bg-brand-accent group-hover:text-brand-primary transition-all duration-500 shadow-sm">
              <Cpu className="w-8 h-8" />
            </div>
            <p className="text-2xl font-display font-bold mb-2">Reduced Manual Effort</p>
            <p className="text-xs font-bold text-brand-muted uppercase tracking-wider">Screening & Sourcing</p>
          </div>
          <div className="group">
            <div className="w-16 h-16 rounded-2xl bg-brand-secondary flex items-center justify-center mx-auto mb-6 group-hover:bg-brand-accent group-hover:text-brand-primary transition-all duration-500 shadow-sm">
              <Zap className="w-8 h-8" />
            </div>
            <p className="text-2xl font-display font-bold mb-2">Faster Cycles</p>
            <p className="text-xs font-bold text-brand-muted uppercase tracking-wider">Slash Time-to-Hire</p>
          </div>
          <div className="group">
            <div className="w-16 h-16 rounded-2xl bg-brand-secondary flex items-center justify-center mx-auto mb-6 group-hover:bg-brand-accent group-hover:text-brand-primary transition-all duration-500 shadow-sm">
              <Star className="w-8 h-8" />
            </div>
            <p className="text-2xl font-display font-bold mb-2">Higher Quality</p>
            <p className="text-xs font-bold text-brand-muted uppercase tracking-wider">Better Match Pipelines</p>
          </div>
          <div className="group">
            <div className="w-16 h-16 rounded-2xl bg-brand-secondary flex items-center justify-center mx-auto mb-6 group-hover:bg-brand-accent group-hover:text-brand-primary transition-all duration-500 shadow-sm">
              <Target className="w-8 h-8" />
            </div>
            <p className="text-2xl font-display font-bold mb-2">Predictability</p>
            <p className="text-xs font-bold text-brand-muted uppercase tracking-wider">Outcome Focus</p>
          </div>
          <div className="group">
            <div className="w-16 h-16 rounded-2xl bg-brand-secondary flex items-center justify-center mx-auto mb-6 group-hover:bg-brand-accent group-hover:text-brand-primary transition-all duration-500 shadow-sm">
              <ShieldCheck className="w-8 h-8" />
            </div>
            <p className="text-2xl font-display font-bold mb-2">Zero Upfront</p>
            <p className="text-xs font-bold text-brand-muted uppercase tracking-wider">Financial Risk</p>
          </div>
        </div>
      </div>
    </section>
  );
};
